import { RootState } from "shared/config/store"

export const selectUserAgreementTitle = (state: RootState) => state.userAgreement.title

export const selectUserAgreementType = (state: RootState) => state.userAgreement.type

export const selectUserAgreementTenantName = (state: RootState) => state.userAgreement.tenantName

export const selectUserAgreementTextContent = (state: RootState) => state.userAgreement.textContent 

export const selectIsUserAgreementModalOpen = (state: RootState) => state.userAgreement.isUserAgreementModalOpen